<template>
  <div class="price-tip">
    <!-- now on -->
    <p>{{$t('messages.deposit.deposit58')}}{{timeStr}}, {{$t('messages.deposit.deposit59')}}</p>
    <div class="price-tip-table">
      <table>
          <thead>
            <tr class="th-tr">
              <th class="th1">{{$t('messages.deposit.deposit2')}}</th>
              <th class="th2">{{$t('messages.deposit.deposit3')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in realList" :key="i" class="tr">
              <td :class="{'tdl':i===realList.length-1}">{{ item.t }}</td>
              <td :class="{'tdr':i===realList.length-1}">{{ item.v }}</td>
            </tr>
          </tbody>
        </table>
    </div>
    <template v-if="holidayNow"> 
      <p>{{$t('messages.deposit.deposit4')}} 
      </p>
      <p style="margin-top: 20px;">{{$t('messages.deposit.deposit5')}}</p>
      <p style="font-weight: 400;color: #606266;font-size: 14px;">{{$t('messages.deposit.deposit6')}}</p>
      <p>{{$t('messages.deposit.deposit7')}}</p>
    </template>
    
    <template v-else>
      <p>{{$t('messages.deposit.deposit8')}}</p>
      <p style="margin-top: 20px;">{{$t('messages.deposit.deposit5')}}</p>
      <p>{{$t('messages.deposit.deposit9')}}</p>
      <p style="font-weight: 400;color: #606266;font-size: 14px;">{{$t('messages.deposit.deposit10')}}</p>
      <p>{{$t('messages.deposit.deposit11')}}</p>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
      return {
      }
  },
  computed:{
    realList(){
      let list;
      let amount = this.$t('messages.other.other55')
      let sign1 = this.$t('messages.support.support37')
      let sign2 = this.$t('messages.support.support38')
      if(this.holidayNow){
        list = [
          {
            t:`${amount} < ${sign1}1000${sign2}`,
            v:'8%',
          },
          {
            t:`${amount} >= ${sign1}1000${sign2}`,
            v:'12%',
          },
        ]
      }else{
        list = [
          {
            t:`${sign1}500${sign2} <= ${amount} <= ${sign1}999${sign2}`,
            v:'5%',
          },
          {
            t:`${sign1}1000${sign2} <= ${amount} <= ${sign1}4999${sign2}`,
            v:'10%',
          },
          {
            t:`${amount} >= ${sign1}5000${sign2}`,
            v:'12%',
          },
        ]
      }
      return list;
    },
    timeStr(){
      let str = this.$t('messages.deposit.deposit65')
      if(this.holidayNow){
        // str = `2024.08.14 to 2024.08.31`
        let format = 'YYYY-MM-DD' 
        console.log('this.holiday',this.holiday);
        let start = moment(this.holiday.start).format(format)
        let end = moment(this.holiday.end).format(format)
        let to = this.$t('messages.deposit.deposit66')
        str = ` ${start} ${to} ${end}`
      }
      return str
    },
    ...mapState(['holiday']),
    ...mapGetters(['holidayNow']),
  }
}
</script>


<style lang="scss">
.price-tip{
  margin-bottom: 32px;
  >p{
    font-weight: 400;
    color: #303133;
    font-size: 16px;
    line-height: 24px;
    word-spacing: 2px;
    &:nth-child(5),&:last-child{
      font-weight: 400;
      color: rgb(96, 98, 102);
      font-size: 14px;
    }
  }
  .price-tip-table{
    margin-bottom: 8px;
    table {
      border-collapse: collapse;
      margin-top: 12px;
      width: 550px;
      margin-bottom: 12px;
      th {
        text-align: left;
        padding: 12px 16px;
        border: 1px solid #ddd;
        font-weight: 400;
        color: #303133;
      }
      td {
        text-align: left;
        padding: 12px 16px;
        background: #FFFFFF;
        border: 1px solid #ddd;
      }
      .th-tr{
        // background: #dce8ff;
        background: #FAFCFF;
      }
      .tr{
        td{
          &:first-child{
            width: 60%;
          }
          &:last-child{
            width: 40%;
            color: #1861F2;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 766px) {
  .price-tip{
    .price-tip-table{
      table{
        width: 100%;
        .tr{
          td{
            &:first-child{
              width: 75%;
            }
            &:last-child{
              width: 25%;
              color: #1861F2;
            }
          }
        }
      }
    }
  }
}
</style>